import React, { useEffect, useState } from "react";

import Head from "next/head";

import FooterNavComponent from "../../components/FooterComponent/FooterNavComponent/FooterNavComponent";
import GetInTouchComponent from "../../components/FooterComponent/GetInTouchComponent/GetInTouchComponent";
import HeaderComponent from "../../components/HeaderComponent/HeaderComponent";
import TrustedByComponent from "../../components/HomeComponent/TrustedByComponent/TrustedByComponent";
import { NextHead } from "../../components/NextHead/NextHead";
import AboutOurTalentComponent from "../../components/TalentComponent/AboutOurTalentComponent/AboutOurTalentComponent";
import MiniTestimonialComponent from "../../components/TalentComponent/MiniTestimonialComponent/MiniTestimonialComponent";
import TalentComponent from "../../components/TalentComponent/TalentComponent";
import { _fetchFooterCmsData } from "../../helper/service";
import { AxiosInstance } from "../../utilities";

const initialCmsData = {
  heading: null,
  sub_heading: null,
  about: null,
  image: null,
}
const initialAboutUsCmsData = {
    about_us: null,
    image: null,
    mission: null,
    vision: null,
};
export default function OurTalentPage(props) {
  const [ourTalentCMS, setOurTalentCMS] = useState(props.cmsData);
  const [aboutUsCms, setAboutUsCms] = useState(
    props.aboutUsData || initialAboutUsCmsData
  );
  useEffect(() => {
    const fetch_about_us_cms_data = () => {
      const params = { slug: "our-talent" };
      if (props.previewKey) {
        params.previewKey = props.previewKey;
      }

      AxiosInstance(4008, "application/json")
        .post("/pages", params)
        .then((resp) => {
          const response = resp && resp.data;
          if (
            response &&
            (response.status === 200 || response.status === "200")
          ) {
            const responseData = response.data;
            const ourTalentCmsClone = { ...ourTalentCMS };
            if (responseData && Array.isArray(responseData.data)) {
              const data = responseData.data;
              for (let i = 0; i < data.length; i++) {
                ourTalentCmsClone[data[i]["key"]] = data[i];
              }
            }
            setOurTalentCMS(ourTalentCmsClone);
          }
        })
        .catch((err) => console.log(err));
    };
    // if props are missing we have to fetch data
   fetch_about_us_cms_data();
  }, []);

  return (
    <>
      <NextHead {...props.seoData} />
      <Head>
        <link rel="canonical" href={`${process.env.BASE_URL}/our-talent`} />
      </Head>
      <HeaderComponent />
      <TalentComponent {...props} content={ourTalentCMS} />
      <TrustedByComponent />
      <AboutOurTalentComponent  content={ourTalentCMS} aboutUsCms={aboutUsCms}/>
      <MiniTestimonialComponent />
      <GetInTouchComponent/>
      <FooterNavComponent />
    </>
  );
}

export async function getServerSideProps(context) {
  let cmsData = initialCmsData;
  let seo = {};

  const params = { slug: "our-talent" };
  await AxiosInstance(4008, "application/json")
    .post("/pages", params)
    .then((resp) => {
      const response = resp && resp.data;
      if (response?.status == 200) {
        const responseData = response.data;
        seo = responseData?.seo;
        const ourTalentCmsClone = { ...cmsData };
            if (responseData && Array.isArray(responseData.data)) {
              const data = responseData.data;
              for (let i = 0; i < data.length; i++) {
                ourTalentCmsClone[data[i]["key"]] = data[i];
              }
            }
            cmsData = ourTalentCmsClone;
          }
          
      })
    
    .catch((err) => console.log(err));

    let aboutUsData = initialAboutUsCmsData;
    let params1 = { slug: "about-us" };
    await AxiosInstance(4008, "application/json")
      .post("/pages", params1)
      .then((resp) => {
        const response = resp && resp.data;
        if (response && (response.status === 200 || response.status === "200")) {
          const responseData = response.data;
          responseData &&
            responseData.data.forEach((item) => {
              if (item.key === "about_us") {
                aboutUsData.about_us = item;
              }
              if (item.key === "image") {
                aboutUsData.image = item;
              }
              if (item.key === "mission") {
                aboutUsData.mission = item;
              }
              if (item.key === "vision") {
                aboutUsData.vision = item;
              }
            });
        }
      })
      .catch((err) => console.log(err));
  const footerData = await _fetchFooterCmsData();
  const seoData = seo === undefined ? "" : seo

  return {
    props: {
      cmsData,
      seoData,
      footerData,
      aboutUsData,
    },
  };
}
